const _ = require('lodash');

const cachedTemplates = {};

module.exports = function ($compile, cardDetailService) {
    return {
        restrict: 'E',
        scope: {
            card: '=',
            productCollection: '=?'
        },
        controller: [
            '$scope', function ($scope) {
                this.openCardDetail = function (id, stateParams) {
                    cardDetailService.openCardDetail($scope.card, id, stateParams);
                };

                this.closeCardDetail = function () {
                    cardDetailService.closeCardDetail();
                };

                this.isDetailExpanded = function () {
                    return cardDetailService.openCard === $scope.card;
                };

                this.getPosition = function () {
                    return $scope.card.position;
                };
            }
        ],
        controllerAs: 'cardCtrl',
        link(scope, element) {
            const directiveScope = _.merge(scope.$new(true), scope.card.data);
            const selector = (scope.card.isDetail ? '._cardDetail-content' : '._card') + ':first';

            let compiled;

            if (scope.card.template in cachedTemplates) {
                compiled = cachedTemplates[scope.card.template];
            } else {
                compiled = $compile(scope.card.template);
                cachedTemplates[scope.card.template] = compiled;
            }

            compiled(directiveScope, function (clonedElement) {
                element.find(selector).html(clonedElement);
            });

            scope.$on('cardCtrl:getCardPosition', function (e, callback) {
                e.stopPropagation();
                if (typeof callback === 'function') {
                    callback(scope.card.position);
                }
            });
        },
        template: require('./card-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/card-directive.js
 **/